export default __webpack_public_path__ + "static/media/logo.1b0de616.png";